import { render, staticRenderFns } from "./FormAcessoPessoa.vue?vue&type=template&id=f31e1706&scoped=true"
import script from "./FormAcessoPessoa.vue?vue&type=script&lang=js"
export * from "./FormAcessoPessoa.vue?vue&type=script&lang=js"
import style0 from "./FormAcessoPessoa.vue?vue&type=style&index=0&id=f31e1706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e1706",
  null
  
)

export default component.exports